import { Flex } from 'antd'
import { useState } from 'react'
import { ButtonPrimary, DropdownWithDelete } from '~/features/shared/components'
import { Icon } from '~/features/shared/icons'
import { UIChatItem } from '../../../types'

type Props = {
  item: UIChatItem
  onSend: () => Promise<void>
  onDelete?: () => Promise<void>
}

export const Footer = ({ item, onSend, onDelete }: Props) => {
  const [isLoading, setLoading] = useState(false)

  const isDraft = item?.status === 'DRAFT'

  const handleClick = async () => {
    setLoading(true)
    await onSend()
    setLoading(false)
  }

  if (!isDraft) {
    return <></>
  }

  return (
    <Flex className="w-full" gap={8} align="center">
      <ButtonPrimary
        onClick={handleClick}
        loading={isLoading}
        icon={<Icon name="bolt" />}
      >
        Send
      </ButtonPrimary>

      {onDelete && <DropdownWithDelete items={[]} onDelete={onDelete} />}
    </Flex>
  )
}
